import React, { forwardRef } from "react";

import { concatClassNames } from "../../utils/styles";
import { ClickableProps, LinkProps } from "./types";

import styles from "./Clickable.module.scss";

const isLink = (props: ClickableProps): props is LinkProps => {
    return typeof (props as LinkProps).href === "string";
};

const Link = forwardRef<
    HTMLAnchorElement,
    React.AnchorHTMLAttributes<HTMLAnchorElement> &
        Pick<ClickableProps, "disabled" | "loading" | "onDark" | "icon">
>(function Link(
    { disabled, loading, onDark, icon, href, title, className, ...props },
    ref,
) {
    return (
        <a
            {...props}
            ref={ref}
            href={disabled ? undefined : href}
            className={concatClassNames([
                styles.linkReset,
                className,
                disabled ? styles.disabled : "",
            ])}
        />
    );
});

const Button = forwardRef<
    HTMLButtonElement,
    React.ButtonHTMLAttributes<HTMLButtonElement> &
        Pick<ClickableProps, "loading" | "onDark" | "icon">
>(function Button({ className, loading, onDark, icon, ...props }, ref) {
    return (
        <button
            {...props}
            ref={ref}
            className={concatClassNames([className, styles.buttonReset])}
        >
            {props.children}
            {loading && "Loading..."}
        </button>
    );
});

export const Clickable = forwardRef<
    HTMLButtonElement | HTMLAnchorElement,
    ClickableProps
>(function Clickable(props, ref) {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment */
    if (isLink(props)) {
        return <Link {...props} ref={ref as any} />;
    }
    return <Button {...props} ref={ref as any} />;
    /* eslint-enable */
});
